import useActionReducer from '@admin/hooks/use_action_reducer'
import * as selectors from './selectors'
import Attachments from './attachments'
import * as actions from './actions'
import PropTypes from 'prop-types'
import reducer from './reducer'
import React from 'react'

const AttachmentsContainer = (props) => {

  const [state, handlers] = useActionReducer({
    display_name: 'attachments',
    actions,
    props,
    reducer,
    selectors
  })

  const mergedProps = {
    ...props,
    ...state,
    ...handlers
  }

  return <Attachments { ...mergedProps } />

}

AttachmentsContainer.propTypes = {}

export default AttachmentsContainer